<template>
    <div class="userCenter banxin">
      <div class="leftMenu">
        <div class="leftMenuBox">
          <el-menu :default-active="defaultActive" active-text-color="#333333" text-color="#999999" router>
            <div class="mar-bot-40">
                <p class="fs18 font500">个人中心</p>

                <el-menu-item class="flex-start" index="userInfo"><span class="title">基本资料</span></el-menu-item>
                <el-menu-item class="flex-start" index="address"><span class="title">地址管理</span></el-menu-item>
                <el-menu-item class="flex-start" index="footprint"><span class="title">我的足迹</span></el-menu-item>
                <el-menu-item class="flex-start" index="notices"><span class="title">通知公告</span></el-menu-item>
            </div>
            <div>
                <p class="fs18 font500">交易管理</p>
                <el-menu-item class="flex-start" index="myFindSource"><span class="title">我的询价单</span></el-menu-item>
                <el-menu-item class="flex-start" index="myOrder"><span class="title">我的订单</span></el-menu-item>
                <el-menu-item class="flex-start" index="myEvaluate"><span class="title">评价晒单</span></el-menu-item>
                <el-menu-item class="flex-start" index="asRecord"><span class="title">售后记录</span></el-menu-item>
                <el-menu-item class="flex-start" index="favorites"><span class="title">我的收藏</span></el-menu-item>
            </div>
          </el-menu>
        </div>
      </div>
      <div class="userCenterInfo flex1">
        <router-view></router-view>
      </div>
    </div>
</template>
<script>
export default {
  name: 'userCenter',
  data () {
    return {}
  },
  computed: {
    defaultActive: function () {
      return this.$route.path.replace('/', '')
    }
  },
  // 修改背景色
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background-color:#F6F6F8')
  },
  beforeDestroy () {
    document.querySelector('body').removeAttribute('style')
  }
}
</script>
<style lang="scss" scoped>
.userCenter{
    display: flex;
    margin-top: 30px;
    margin-bottom: 100px;
    .leftMenu{
        width: 200px;
        margin-right: 20px;
        .el-menu{
            padding: 30px;
            border: 0;
            .el-menu-item{
                font-size: 17px;
                padding: 0 !important;
            }
            >>> .el-menu-item:focus, .el-menu-item:hover {
                background: none;
                color: #FF8000 !important;
            }
            >>>  .is-active{
                font-weight: 500;
                color: #FF8000 !important;
            }
        }
    }
}
.title{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/index.vue